<template>
    <div id="conteudomigraplano">
        <div id="banner">
            <div class="premium-card">
                <img class="banner" src="../assets/logo.png" alt="Plano Premium Dracomini" />
                <h2 class="title">Seja Dracomini premium por  <span style="color: #1666cc;" >R$14,90</span> / mês</h2>
                <ul class="benefits">
                    <li v-for="(beneficio, index) in beneficios" :key="index">
                        🟊 {{ beneficio }}
                    </li>
                </ul>
                <button class="subscribe-button" @click.prevent="assinarPlano()">
                    Assinar agora
                </button>
            </div>
        </div>
        <div id="checkout">
            <checkout v-bind:primeira="true" > </checkout>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import checkout from '../checkout.vue';
export default {
    name: 'PlanoPremium',
    components: {
        checkout
    },
    data() {
        return {
            beneficios: [
                'Acesso ilimitado a todos os recursos',
                'Backup automático na nuvem',
                'Suporte prioritário 24h',
                'Temas e ícones exclusivos',
                'Integrações com outras plataformas',
                'Relatórios avançados e exportações'
            ]
        };
    },
    methods: {
        assinarPlano() {
            $("#banner").hide();
            $("#checkout").show();
        }
    },
    mounted(){
        $("#checkout").hide();
    }
};
</script>

<style scoped>
.premium-card {
    max-width: 420px;
    margin: 2rem auto;
    padding: 1.5rem;
    border-radius: 15px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    background: white;
    text-align: center;
    font-family: 'Segoe UI', sans-serif;
}

.banner {
    width: 100%;
    max-height: 200px;
    object-fit: contain;
    margin-bottom: 1rem;
}

.title {
    font-size: 1.6rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 1rem;
}

.benefits {
    list-style: none;
    padding: 0;
    margin: 1rem 0;
    text-align: left;
    color: #555;
}

.benefits li {
    margin: 0.5rem 0;
    font-size: 1rem;
}

.subscribe-button {
    background-color: #6a11cb;
    color: white;
    border: none;
    padding: 0.8rem 1.5rem;
    border-radius: 30px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background 0.3s;
}

.subscribe-button:hover {
    background-color: #5311a3;
}
</style>
